import React from 'react';
import Login from 'pages/Login';
import { DefaultLayout } from './containers';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from 'models/auth';

export default function RouteComponent() {
  const token = useSelector(authSelector.tokenSelector);
  return (
    <BrowserRouter>
      <Switch>
        {localStorage.getItem('idealMerchantId') ? (
          <Route path="/" name="Home" component={DefaultLayout} />
        ) : (
          <>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Redirect from="/" to="/login" />
          </>
        )}
      </Switch>
    </BrowserRouter>
  );
}